import Get from "../Get";
import Post from "../Post";
import getToken from "../token";
export default function FAQ() {
  return Get("FAQ/video");
}
